// Hero Slider
const heroSlider = document.querySelectorAll('[data-slider="hero-slider"]');

const heroSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 12,
  watchOverflow: true,
  effect: windowWidth() > breakpointMd ? 'fade' : 'slide',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  mousewheel: {
    forceToAxis: true,
  },
  breakpoints: {
    992: {
      loop: true,
      speed: 800,
    },
  },
};

heroSlider.forEach((el) => {
  const parentElem = el.closest('.hero-module');

  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');
  const paginationElement = parentElem.querySelector('.swiper-pagination');
  const slides = parentElem.querySelectorAll('.swiper-slide');

  if (slides.length === 1) {
    heroSliderOptions.breakpoints[992].loop = false;
  }

  heroSliderOptions.navigation.prevEl = arrowLeft;
  heroSliderOptions.navigation.nextEl = arrowRight;
  heroSliderOptions.pagination.el = paginationElement;

  new Swiper(el, heroSliderOptions);
});
